module.exports = __webpack_public_path__ + "static/media/breakdownTable.c3ed61f4.png";